import React from 'react'

export default function NotFound() {
    return(
    <h1 style={{height:'88dvh',display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column',color:'black',background: "linear-gradient(to right, #f64f59, #c471ed, #12c2e9)"}}>Page Not Found</h1>
)
}
